import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ThreadIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M11.6 3.333H3.067C2.48 3.333 2 3.797 2 4.364v8.97l2.133-2.058H11.6c.587 0 1.067-.464 1.067-1.03V4.363c0-.566-.48-1.03-1.067-1.03Zm0 6.912H4.133l-1.066 1.03V4.363H11.6v5.882Z" />
    <path
      fillRule="evenodd"
      d="M14.5 5.5v5.833c0 1.013-.82 1.834-1.833 1.834H5.5v-1h7.167c.46 0 .833-.373.833-.834V5.5h1ZM10.667 6.667H4v-1h6.667v1Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.667 8.667H4v-1h6.667v1Z"
      clipRule="evenodd"
    />
  </Icon>
);

export default memo(ThreadIcon);
